const PageTitle = ({title}) => {
    return (
        <p className="text-2xl md:text-3xl text-center text-teal-600 uppercase font-bold">
            {title}
        </p>
    );
}

export default PageTitle;